export const USFlag = ({ className = "", width = 18, height = 11 }) => (
  <svg viewBox="0 0 19 12" width={width} height={height} className={`inline-block ${className}`} aria-label="United States flag" role="img">
    <rect width="19" height="12" fill="#B22234" />
    {[1, 3, 5, 7, 9, 11].map((i) => (
      <rect key={i} y={i * (12 / 13)} width="19" height={12 / 13} fill="#FFFFFF" />
    ))}
    <rect width="8.5" height={12 * (7 / 13)} fill="#3C3B6E" />
    {Array.from({ length: 12 }).map((_, i) => (
      <circle key={i} cx={1.2 + (i % 4) * 2} cy={1.1 + Math.floor(i / 4) * 2.1} r="0.45" fill="#FFFFFF" />
    ))}
  </svg>
);
